import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function EditorialBand() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="relative bg-aubergine-deep overflow-hidden" aria-hidden="false" data-id="element-150">
      {/* Decorative purple glow */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold/10 rounded-full blur-3xl pointer-events-none" data-id="element-151"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gold/10 rounded-full blur-3xl pointer-events-none" data-id="element-152"></div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-24 lg:py-32 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-153">
        {/* Portrait */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={isInView ? {
        opacity: 1,
        x: 0
      } : {}} transition={{
        duration: 1
      }} className="lg:col-span-6" data-id="element-154">
          <div className="relative aspect-[3/4] w-full max-w-lg mx-auto lg:mx-0" data-id="element-155">
            <div className="absolute -inset-4 border border-gold/30" data-id="element-156"></div>
            <div className="absolute -top-4 -left-4 w-16 h-16 border-t border-l border-gold/60" data-id="element-157"></div>
            <div className="absolute -bottom-4 -right-4 w-16 h-16 border-b border-r border-gold/60" data-id="element-158"></div>
            <img src="https://cdn.magicpatterns.com/uploads/kdcQby3WJfUBgffbjKrjmM/14.jpg" alt="Madam Yas" className="relative w-full h-full object-cover object-top" data-id="element-159" />
            <div className="absolute inset-0 bg-gradient-to-t from-aubergine-deep/40 via-transparent to-transparent pointer-events-none" data-id="element-160"></div>
          </div>
        </motion.div>

        {/* Quote panel */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={isInView ? {
        opacity: 1,
        x: 0
      } : {}} transition={{
        duration: 1,
        delay: 0.2
      }} className="lg:col-span-6" data-id="element-161">
          <p className="text-gold font-cinzel text-xs tracking-[0.4em] mb-6" data-id="element-162">
            IN THE STUDIO
          </p>
          <p className="font-cormorant text-bone text-3xl md:text-4xl lg:text-5xl font-light italic leading-snug mb-8" data-id="element-163">
            "Every session is an exchange of trust — held with intention,
            executed with mastery."
          </p>
          <p className="text-silver-muted leading-relaxed mb-10 max-w-md" data-id="element-164">
            Discretion and craft above all. Each visit is shaped by attentive
            preparation and an unwavering respect for the person across from me.
          </p>
          <a href="#contact" className="inline-flex items-center gap-3 px-8 py-4 text-sm uppercase tracking-[0.2em] font-semibold border-2 transition-all duration-300 shadow-[0_0_30px_rgba(183,148,212,0.25)] hover:shadow-[0_0_50px_rgba(183,148,212,0.5)]" style={{
          backgroundColor: '#B794D4',
          color: '#07050A',
          borderColor: '#B794D4'
        }} data-id="element-165">
            Begin Your Journey
            <span aria-hidden data-id="element-166">→</span>
          </a>
        </motion.div>
      </div>
    </section>;
}